import { GET_CERTONA_ATTRIBUTES } from '../actionTypes/CartActionTypes';

export const getCertonaAttributes = (payload) => ({
    type: GET_CERTONA_ATTRIBUTES,
    payload,
});

export default { getCertonaAttributes };
